module.exports = __webpack_public_path__ + "img/change-desc-icon.c523f2f0.svg";